import { VerifyCreditCard } from '@/lib/api/hooks/use-user'
import { Button, Spin } from 'antd'
import React from 'react'

export function CompleteVerifyCreditButton(props) {
  const { mutateAsync: verifyCreditCard, isPending: isCreditCardLoading } =
    VerifyCreditCard()

  const handleCreditCardVerify = async () => {
    try {
      // 取得當前網址作為返回網址
      const return_url = window.location.href

      // 呼叫 API 取得驗證網址
      const response = await verifyCreditCard({ return_url })
      console.log('response', response)

      // 如果有返回網址，則進行重定向
      if (response && response.payUrl) {
        window.location.href = response.payUrl
      }
    } catch (error) {
      console.error('信用卡驗證請求失敗:', error)
    }
  }

  return (
    <Button
      onClick={handleCreditCardVerify}
      loading={isCreditCardLoading}
      {...props}
    >
      {props.children}
      <Spin spinning={isCreditCardLoading} fullscreen={true} />
    </Button>
  )
}
